import { Button, Link } from '@televet/kibble-ui';

const SUPPORT_HANDOFF_LABEL = 'Get help from Otto support';
const SUPPORT_EMAIL_FALLBACK_LABEL = 'Email Otto support';
const SUPPORT_EMAIL_HREF = 'mailto:success@otto.vet';

interface OttoSupportHandoffButtonProps {
  /** Opens the host's support chat. Hosts with no Messenger omit it and get an email link. */
  onSupportHandoffClick?: () => void;
  disabled?: boolean;
}

export function OttoSupportHandoffButton({
  onSupportHandoffClick,
  disabled,
}: OttoSupportHandoffButtonProps) {
  if (!onSupportHandoffClick) {
    return (
      <Link
        href={SUPPORT_EMAIL_HREF}
        data-testid="otto-pilot-support-email"
        size="sm"
        alignSelf="center"
      >
        {SUPPORT_EMAIL_FALLBACK_LABEL}
      </Link>
    );
  }

  return (
    <Button
      data-testid="otto-pilot-support-handoff"
      variant="primary"
      size="sm"
      iconName="chatBubble"
      disabled={disabled}
      onClick={onSupportHandoffClick}
    >
      {SUPPORT_HANDOFF_LABEL}
    </Button>
  );
}
